<template>
	<div>
		<b-modal id="modalChargeForm" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
			<Loader :show="loading || saving"></Loader>
			<div class="fullscreen" v-if="show">
				<div class="head">
					<div class="container">
						<div class="btn icon icon-close invert" @click="close"></div>
						<h1>{{title}}</h1>
					</div>
				</div>
				<div class="content bg-grey">
					<div class="container">

						<b-form-group label="Descripción" class="mt-4">
							<b-form-input
								v-model="form.description"
								placeholder="Ingrese una descripción"
								:state="!validation.hasError('form.description')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese una descripción</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group label="Costo" class="mt-4">
							<div class="input-group" style="width:190px;">
								<div class="input-group-prepend">
									<span class="input-group-text">U$S</span>
								</div>
								<vue-numeric 
									separator="," 
									v-model="form.price" 
									class="form-control text-right" 
									:precision="2" ></vue-numeric>
							</div>
							<b-form-invalid-feedback>Ingrese una price</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="Archivos adjuntos" class="mt-4">
							<UploadMultiple
								v-model="form.files" 
								:placeholder="'Adjuntar archivo'"
								:invalid="validation.hasError('form.images')" 
								@uploading="showLoader"
							></UploadMultiple>
						</b-form-group>

					</div>
				</div>

				<div class="footer">
					<div class="container">
						<div class="btn btn-block btn-primary" @click="save()">
							Continuar
						</div>
					</div>
				</div>

			</div>
		</b-modal>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapState, mapMutations } from 'vuex'
import mixins from '@/mixins/mixins'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

import Loader from '@/components/Loader'
import UploadMultiple from '@/components/UploadMultiple'

export default {
	name: "RepairDamageForm",
	components:{
		Loader,
		UploadMultiple
	},
	mixins:[mixins],
	props:{
		value:{
			type: Array,
			default: () => ([])
		},
		carId:{
			type: String
		},
		damageId:{
			type: String
		},
	},
	data () {
		return {
			show: false,
			loading: false,
			saving: false,
			title: null,
			form: {
				id: null,
				description:null,
				price: 0,
				files: [],
			},
		}
	},
	computed: {
		...mapState(['control']),
	},
	validators: {
		'form.description': function (value) {
			return Validator.value(value).required();
		},
		'form.price': function (value) {
			return Validator.value(value).required();
		},
		// 'form.files': function (value) {
		//	return Validator.custom( () => {
		//		if(value.length<=0){ return true}
		//			return false
		//		})
		//	},
	},
	methods:{
		...mapMutations(['saveControl']),
		open (id) {
			this.form = {
				id: id,
				description:null,
				price: 0,
				files: [],
			}
			if(id > 0){
				this.action = 'update'
				this.title = 'Editar cargo'
				this.load(id)
			}else{
				this.title = 'Reparar daño'
				this.action = 'create'
			}
			
			this.show = true
			this.$bvModal.show('modalChargeForm')
		},
		close () {
			this.$bvModal.hide('modalChargeForm')
		},
		showLoader(data){
			this.loading  = data
		},
		load(id){
			this.loading = true
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					charge (id: $id) {
						id
						description
						price
						files{
							id
							filename
							extension
							type
							url
							urlThumb
						}
					}
				}`,
				variables: {
					id
				},
			})
			.then((data) => {
				this.form = data.data.charge;
				this.loading = false
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true

				let dataInput = {
					car_id 			: this.carId,
					damage_id 		: this.damageId,
					description		: this.form.description,
					price			: this.form.price,
					files			: this.form.files.map(a => a.id)
				}

				if(this.action == 'create' ){
					this.create(dataInput)
				}else
				if(this.action == 'update' ){
					this.update(this.form.id, dataInput)
				}
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:ChargeInput! ){
					chargeCreate( data: $data) {
						id
						created_at
					}
				}`,
				variables: {
					data
				}
			})
			.then((data) => {
				this.chargeCreated = data.data.chargeCreate
				this.saving = false
				this.close()
				this.$emit('changed')
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		update (id, data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data:ChargeInput! ){
					chargeUpdate( id: $id, data: $data) {
						id
						created_at
					}
				}`,
				variables: {
					id,
					data
				}
			})
			.then((data) => {
				this.chargeUpdate = data.data.chargeUpdate
				this.saving = false
				this.close()
				this.$emit('changed')
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		delete (id) {
			this.saving = true
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!){
					chargeDelete( id: $id ) {
						id
					}
				}`,
				variables: {
					id
				}
			})
			.then(() => {
				this.saving = false
				this.close()
				this.$emit('changed')
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		}
	}

}
</script>

<style lang="scss" scoped>
.list-item{
	margin:4px 0px;
	display: flex;

	> div:first-child{
		flex-grow: 1;
	}
}
</style>